import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { routes } from '../../../utils/routes';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store/store';
import { authAppleExchangeTokenAction } from '../../../redux/actions/AuthActionsNew';
import { getOnboardingStateAction } from '../../../redux/actions/UserActions/OnboardingActions';

const AuthAppleSuccess: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>()

    // const workspaceId = localStorage.getItem("activeWorkspaceId");

    useEffect(() => {
        const bridgeToken = searchParams.get('bridge_token');

        if (bridgeToken) {
            dispatch(authAppleExchangeTokenAction({ bridge_token: bridgeToken || "" })).unwrap().then(async (res) => {
                if (res.success) {
                    localStorage.setItem("token_user", res?.data?.token);
                    try {
                        const onboardingRes = await dispatch(getOnboardingStateAction() as any).unwrap();
                        if (onboardingRes?.data && onboardingRes.data.completed === false) {
                            navigate(routes.onboarding, { replace: true });
                            return;
                        }
                    } catch (onboardingErr) {
                        console.error("Failed to fetch onboarding state after login:", onboardingErr);
                    }
                    navigate(routes?.dashboard, { replace: true });
                } else {
                    navigate(routes.login, { replace: true });
                }
            })
        } else {
            navigate(routes.login, { replace: true });
        }
    }, [searchParams, navigate, dispatch]);

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f4f6f8',
            }}
        >
            <CircularProgress size={60} thickness={5} />
            <Typography mt={2} variant="h6" sx={{ color: '#555' }}>
                Authenticating...
            </Typography>
        </Box>
    );
};

export default AuthAppleSuccess;
